// Admin JavaScript entry point
import $ from "jquery";
window.jQuery = window.$ = $;

// Import Rails UJS for handling method: :delete and other Rails features
import Rails from "@rails/ujs";
Rails.start();

import Popper from "popper.js";
window.Popper = Popper;
import "bootstrap";
import Turbolinks from "turbolinks";
Turbolinks.start();

import "jquery-timepicker/jquery.timepicker";
import Swal from "sweetalert2";
window.Swal = Swal;

import "cocoon";

// Import admin-specific controllers
import "../controllers/admin/activity_open_day_controller";
import "../controllers/admin/activity_open_days_controller";
import "../controllers/admin/company_activation_controller";
import "../controllers/admin/customer_search_controller";
import "../controllers/admin/facilities_controller";
import "../controllers/admin/location_controller";
import "../controllers/admin/tinymce_controller";

console.log("Admin JavaScript loaded successfully");
